import * as actionTypes from 'constants/spoofing';

export const {
  SPOOF_REQUESTED,
  SPOOF_STARTED,
  SPOOF_CANCELLED,
  SPOOF_STOPPED,
  SPOOF_ERRORED,
} = actionTypes;

export function requestSpoof(id) {
  return {
    type: SPOOF_REQUESTED,
    payload: id,
  };
}

export function startSpoof(id) {
  return {
    type: SPOOF_STARTED,
    payload: id,
  };
}

export function cancelSpoof() {
  return { type: SPOOF_CANCELLED };
}

export function stopSpoof() {
  return { type: SPOOF_STOPPED };
}

export function errorSpoof() {
  return { type: SPOOF_ERRORED, error: true };
}
